package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class UpdateTicketStatusUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(ticketId: String, status: String) {
        repo.updateStatus(ticketId = ticketId, status = status)
    }
}
